import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'app-edit-grid-over-pop-up',
    templateUrl: './edit-grid-over-pop-up.component.html',
    styleUrls: ['./edit-grid-over-pop-up.component.scss'],
    standalone: false
})
export class EditGridOverPopUpComponent implements OnInit {
  @Input() data: any;
  _currentData: any = {};
  constructor() {
    this._currentData.action = "MODIFY";
    this._currentData.configForm = {
      "submitButton": false,
      "cancelButton": false,
      "filterForm": false,
      "clearOnSave": false,
      "delegateSave": true,
      "cancelRoute": '',
      'delta_update': false
    }
    this._currentData.showForm = false
  }

  ngOnInit(): void {
    console.log("input data data is", this.data);
    this.makeBlocks();
  }
  makeBlocks() {
    if (this.data && this.data.configData && this.data.configData.whole_resource.list.fields) {
      this._currentData.currentFormFields = {
        blocks: [{
          name:'edit',
          fields:this.data.configData.whole_resource.list.fields
        }]
      };
      this._currentData.showForm = true;
      this._currentData.defaultFormData = this.data.row_data
    }

  }
  onSaveFinished(event) {

  }
  questionChange(event) {

  }
}
